import React, { useState } from "react";
import { motion } from "framer-motion";
import "./ForLoopDiagram.css";

const ForLoopDiagram = () => {
  const [step, setStep] = useState(0);
  const range = [0, 1, 2, 3, 4];

  const handleNext = () => {
    if (step < range.length) setStep(step + 1);
  };

  return (
    <div className="for-loop-diagram">
      <h3>
        Как работает цикл <code>for</code> в Python
      </h3>

      <div className="code-block">
        <pre>
          <code>
            for i in range(5):{"\n"}    print(i)
          </code>
        </pre>
      </div>

      <div className="loop-progress-bar">
        <div
          className="loop-progress-bar-fill"
          style={{ width: `${(step / range.length) * 100}%` }}
        />
      </div>

      <div className="output">
        <strong>Вывод:</strong>
        <ul>
          {range.slice(0, step).map((val) => (
            <motion.li
              key={val}
              initial={{ opacity: 0, x: -10 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.3, delay: val * 0.1 }}
            >
              i = {val} → print({val})
            </motion.li>
          ))}
        </ul>
      </div>

      <button
        disabled={step >= range.length}
        onClick={handleNext}
        className="loop-button"
      >
        {step < range.length ? "Следующий шаг" : "Цикл завершен ✅"}
      </button>
    </div>
  );
};

export default ForLoopDiagram;